export type LanguageCode = 'ko' | 'en' | 'ja' | 'zh' | 'vi' | 'ru' | 'ar' | 'th' | 'id';

export const LANGUAGE_CODE: Record<LanguageCode, string> = {
    ko: 'ko-KR',
    en: 'en-US',
    ja: 'ja-JP',
    zh: 'zh-TW',
    vi: 'vi-VN',
    ru: 'ru-RU',
    ar: 'ar-AE',
    th: 'th-TH',
    id: 'id-ID',
};

export const localeSelector = (lang: LanguageCode) => LANGUAGE_CODE[lang];
